import { isSmartNoteBusy, isGeneratingSession, isSkippedSession } from '../../lib/sessionStatus';
import { isAwaitingTranscribe } from './PendingAudioList';

const STATUS_PILL = {
  uploaded: { label: 'Queued', tone: 'neutral' },
  transcribing: { label: 'Transcribing…', tone: 'working' },
  ready: { label: 'Ready to edit', tone: 'todo' },
  drafted: { label: 'Draft', tone: 'todo' },
  published: { label: 'Published', tone: 'done' },
  error: { label: 'Sync failed', tone: 'error' },
};

/** Where a Studio session stands, as the label and tone its badge shows. */
export function sessionPill(item) {
  if (isSkippedSession(item) && !item.draft_id) return { label: 'Skipped', tone: 'neutral' };
  if (isAwaitingTranscribe(item)) return { label: 'Not transcribed', tone: 'neutral' };
  if (isSmartNoteBusy(item) || isGeneratingSession(item)) return { label: 'Processing…', tone: 'working' };
  if (item.auto_sync_multimodal && !item.draft_id && item.status === 'ready') return { label: 'Ready to review', tone: 'todo' };
  return STATUS_PILL[item.status] || STATUS_PILL.uploaded;
}

const REVIEW_LABELS = ['Ready to review', 'Ready to edit'];

export const SESSION_FILTERS = [
  { id: 'all', label: 'All', match: () => true },
  { id: 'review', label: 'Ready to review', match: (p) => REVIEW_LABELS.includes(p.label) },
  { id: 'draft', label: 'Draft', match: (p) => p.label === 'Draft' },
  { id: 'published', label: 'Published', match: (p) => p.tone === 'done' },
  { id: 'failed', label: 'Failed', match: (p) => p.tone === 'error' },
];

/** Sessions on the chosen tab whose title, class or chapter contains the search text. */
export function filterSessions(items, filterId, query) {
  const tab = SESSION_FILTERS.find(f => f.id === filterId) || SESSION_FILTERS[0];
  const q = (query || '').trim().toLowerCase();
  return items.filter((item) => {
    if (!tab.match(sessionPill(item))) return false;
    if (!q) return true;
    return [item.title, item.title_hint, item.detected_class_name, item.detected_lesson_name]
      .some(text => (text || '').toLowerCase().includes(q));
  });
}
